/**
 * 头像色板。main 为主体色，shade 为同系深色（阴影/细节）。
 * 部件库所有 SVG 均从这里取色，保证全局风格统一。
 *
 * age 标记（仅发色使用）：'mid'=中年起使用，'old'=老年；
 * 未标记 = 年轻可用。随机 NPC（默认 young）不会抽到带 age 的发色。
 */
export interface Tone {
  main: string;
  shade: string;
  age?: 'mid' | 'old';
}

/** 肤色（浅 → 深），全年龄通用 */
export const SKINS: Tone[] = [
  { main: '#ffe3d0', shade: '#f1c3a6' },
  { main: '#fdd3b4', shade: '#e9b18c' },
  { main: '#efc49c', shade: '#d6a172' },
];

/** 发色：银灰/纯白是年龄信号色，见 docs/头像部件系统.md */
export const HAIR_COLORS: Tone[] = [
  { main: '#33303a', shade: '#211f28' },
  { main: '#5d4333', shade: '#46331f' },
  { main: '#8a5a3b', shade: '#6e462d' },
  { main: '#d9a75f', shade: '#bb8a45' },
  { main: '#a34f35', shade: '#853c27' },
  { main: '#b9bcc8', shade: '#979aab', age: 'mid' },
  { main: '#d98aa6', shade: '#b96f88' },
  { main: '#ecebe6', shade: '#cfccc4', age: 'old' },
];

/** 瞳色（PNG 虹膜模板染色用），全年龄通用 */
export const EYE_COLORS: string[] = [
  '#6b5d4f', // 深棕
  '#3a3630', // 黑
  '#4a7dc4', // 蓝
  '#43a377', // 绿
  '#8a5aa8', // 紫
  '#c4756b', // 红棕
  '#b8862e', // 琥珀
  '#5a8a92', // 灰青
];

/** 线稿色（五官描边统一用） */
export const LINE = '#423a34';
